




































import {
  defineComponent,
  watchEffect,
  reactive,
  ref,
  Ref,
  onMounted,
  watch,
} from '@vue/composition-api';

import { useSelectable, useRouter } from '@ideavivat/vivat-2';

import useAuth from '@/useAuth';

import {
  getRole,
  updateRole,
  getPermissions,
} from '@/api/index';

const CommonFormWithRoleEditor = defineComponent({
  props: {
    roleId: {
      type: String,
      required: true,
    },
    module: {
      type: Array,
      default: () => ([]),
    },
  },
  setup(props) {
    const { router } = useRouter();

    const form = reactive({
      name: '',
      permissions: [],
      fallbackName: '',
      call: async () => {
        await updateRole(
          props.roleId as any,
          form.name === form.fallbackName ? null : form.name,
          form.permissions,
        );
      },
      state: {
        value: 'READY',
      },
    });

    const {
      selectedItems: selectedList,
      onSelect: onSelectList,
      isSelected: isSelectedList,
    } = useSelectable(form.permissions, (elm: any) => elm.id);
    watchEffect(() => {
      selectedList.value = form.permissions;
    });

    function onSelect(items: any, setTo: any) {
      onSelectList(items, setTo);
      form.permissions = selectedList.value;
    }

    const doneModal = ref(null);

    const permissions: Ref<any[]> = ref([]);

    async function callGetRole() {
      const { name, permissions: permList } = (await getRole(props.roleId)).role;
      form.name = name;
      form.fallbackName = name;
      form.permissions = permList.map((p: any) => p.id);
    }

    const moduleNameToDisplay = {
      register: 'สมัครสมาชิก',
      ticket: 'ตั๋วเข้าชม',
      speaker: 'ผู้พูด',
      live: 'ถ่ายทอดสด',
      session: 'ถ่ายทอดสด',
      stream: 'ลิ้งค์ถ่ายทอดสด',
      agenda: 'กำหนดการ',
      vote: 'โหวต',
      qa: 'ถาม/ตอบ',
      menu: 'แสดงเมนู',
      chat: 'แชท',
      landing: 'หน้าเว็บ',
      user: 'ผู้ดูแลระบบ',
    };

    onMounted(async () => {
      const data = await getPermissions();
      props.module.forEach((moduleName: any) => {
        const temporaryPerm = [];
        const foundIndex = []; // TODO : implement this for reduce process time
        for (let i = 0; i < data.length; i += 1) {
          if (moduleName === data[i].module_name) {
            foundIndex.push(i);
            temporaryPerm.push(data[i]);
          }
        }
        permissions.value.push({
          moduleName,
          displayName: (moduleNameToDisplay as any)[moduleName],
          permissions: temporaryPerm,
        });
      });

      await callGetRole();
    });

    watch(() => props.roleId, async (newVal) => {
      if (newVal) await callGetRole();
    });

    return {
      doneModal,
      form,
      selectedList,
      onSelect,
      isSelectedList,
      permissions,
    };
  },
});

export default CommonFormWithRoleEditor;
